// extracted by mini-css-extract-plugin
export default {"container":"ContactConfirmation_container__4YTOx"};